import { get, post } from '../index'

// 短视频
export default {
  // 新增
  shortvideoAdd  (querys) {
    return post('/shortvideo/admin/video/add', querys)
  },
  // 编辑
  shortvideoUpdate (querys) {
    return post('/shortvideo/admin/video/update', querys)
  },
  // 关联配置-关联商品
  shortvideoConfig (querys) {
    return get('/shortvideo/admin/config', querys)
  },
  // 获取优惠插件权限
  shortvideoDiscount (querys) {
    return get('/shortvideo/admin/discount', querys)
  },
  // 修改状态
  shortvideoStatus (querys) {
    return post('/shortvideo/admin/video/status', querys)
  },
  // 视频列表-视频管理
  shortvideoList (querys) {
    return get('/shortvideo/admin/video/list', querys)
  },
  // 单个视频数据统计
  shortvideoVideo (querys) {
    return get('/shortvideo/admin/count/video', querys)
  },
  // 获取单个短视频：员工/客户 列表数据
  shortvideoUserList (querys) {
    return post('/shortvideo/admin/count/user_list', querys)
  },
  // 短视频所有数据统计-数据管理
  shortvideoAll (querys) {
    return get('/shortvideo/admin/count/all', querys)
  },
  // 短视频统计图 数据获取
  shortvideoTable (querys) {
    return get('/shortvideo/admin/count/table', querys)
  },
  // 获取短视频的数据开始时间
  shortVideoInitialTime (querys) {
    return get('/shortvideo/admin/initial_time', querys)
  },
  // 获取指定时间内的浏览数据
  shortvideoDayList (querys) {
    return get('/shortvideo/admin/count/day_list', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/shortvideo.js